import Text from '@cartwhl/ui/base/Text';

import { publicPageGutters } from '../../public-page-gutters';

export default function MotionAsDataSection() {
  return (
    <section className="pb-(--vertical-spacing)">
      <div className={publicPageGutters}>
        <Text
          as="h2"
          variant="web/body/medium/lg"
          lg:variant="web/body/medium/xl"
          className="mb-16"
        >
          Motion as data
        </Text>
        <Text
          as="p"
          variant="web/body/medium/md"
          lg:variant="web/body/medium/24"
          className="text-tertiary max-w-[850px]"
        >
          Cartwheel’s motion data offering treats movement as a first-class data
          modality. We capture, generate, and transform motion into structured,
          reusable datasets that can be used to train models, evaluate behavior,
          simulate interaction, or derive insight — independent of any specific
          character, animation, or render pipeline.
          <br />
          <br />
          Because Cartwheel operates across capture, generation, and
          interpolation, we can produce motion datasets that are both
          semantically rich and structurally consistent, at a scale and fidelity
          that traditional motion capture pipelines cannot support.
        </Text>
      </div>
    </section>
  );
}
